type LabelProps = {
  title: string;
  className?: string;
};

export const Label = ({ title, className = '' }: LabelProps) => {
  return <p className={`text-md ${className}`}>{title}</p>;
};